<template lang="pug">
	.cluster-log(v-if="showed")
		.card
			.card-header
				i.fa.fa-exchange
				span Cluster requests
				button.close-button.btn.btn-sm.btn-ghost-secondary(type="button" @click="close()")
					i.fa.fa-times
			.card-body.collapse.show
				.toolbar
					label.auto-scroll
						input(type="checkbox" v-model="autoScroll")
						| &nbsp;Auto scroll
					button.btn.btn-sm.btn-secondary(type="button" @click="clear()")
						i.fa.fa-trash
						| &nbsp;&nbsp;Clear
				.logs(v-show="Cluster.getLogs().length > 0" ref="logs")
					.log(v-for="entry in Cluster.getLogs()" :key="entry.id" :class="[entry.direction, entry.kind]")
						span.time {{formatTime(entry.time)}}
						span.peer {{entry.direction === 'out' ? 'to' : 'from'}} node {{entry.serverId}}
						span.kind {{entry.kind}}
						span.action(v-if="entry.action") {{entry.action}}
						span.details(v-if="entry.details") {{entry.details}}
				.empty(v-if="!Cluster.getLogs().length")
					span Waiting for requests between nodes...
</template>

<script>

	import Screen					from './../../mixins/screen'

	import { Server }			from './../../services/Server'
	import { User }				from './../../services/User'
	import { Cluster }		from './../../services/Cluster'

	export default {
		name: "ClusterLog",
		mixins: [Screen],
		screen: {
			updateOn: ["Cluster Log Changed"]
		},
		data() {

			this.Cluster = Cluster;

			return {
				autoScroll: true
			};

		},
		watch: {
			//Пока окно открыто, подписываем соединение на поток запросов между нодами,
			//а при закрытии - отписываем (сервер присылает записи только тем, кто смотрит лог)
			showed(isShowed) {

				if (isShowed) this.startWatching();
				else this.stopWatching();

			}
		},
		methods: {
			collectData(reason) {

				//Пришли новые записи - если включена автопрокрутка, показываем последние
				if (reason === 'Cluster Log Changed' && this.autoScroll) this.scrollToBottom();

			},
			//Подписываем соединение на поток запросов между нодами (только супер-админы).
			//Запрос уходит на свою ноду: она собирает запросы со всего кластера
			startWatching() {

				if (!User.currentUser?.Tags?.['super-admin']) return;

				Server.sendToServer({
					GetClusterLog: {}
				}, Server.getPrimaryServerId());

			},
			//Отписываем соединение от потока запросов между нодами
			stopWatching() {

				Server.sendToServer({
					StopClusterLog: {}
				}, Server.getPrimaryServerId());

			},
			//Прокручиваем лог вниз, чтобы были видны новые записи
			scrollToBottom() {

				this.$nextTick(() => {

					let logs = this.$refs.logs;

					if (logs) logs.scrollTop = logs.scrollHeight;

				});

			},
			//Время записи в формате ЧЧ:ММ:СС
			formatTime(time) {

				return new Date(time).toLocaleTimeString();

			},
			clear() {

				Cluster.clearLogs();

			},
			close() {

				this.hide();

			}
		}
	}
</script>

<style lang="sass">

	.cluster-log
		position: absolute
		z-index: 2000
		left: 0
		top: 0
		right: 0
		bottom: 0
		background-color: rgba(0, 0, 0, 0.6)

		.card
			width: 80%
			position: absolute
			left: 0
			right: 0
			top: 0
			bottom: 0
			margin: auto
			display: flex
			height: 650px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			.card-header
				display: flex
				align-items: center
				color: #fff

				i
					margin-right: 8px

				.close-button
					margin-left: auto
					color: #fff

			.card-body
				display: flex
				flex-direction: column
				overflow: hidden

				.toolbar
					display: flex
					align-items: center
					margin-bottom: 8px
					color: #e4e7ea

					.auto-scroll
						margin: 0

					button
						margin-left: auto

				.logs
					overflow-y: auto
					font-size: 0.72rem
					font-family: monospace

					.log
						padding: 2px 4px
						border-bottom: 1px solid rgba(0, 0, 0, 0.15)
						color: #e4e7ea
						white-space: nowrap

						&.out
							background-color: rgba(32, 168, 216, 0.08)

						&.heartbeat
							color: #9da5b1

						.time
							margin-right: 8px
							color: #9da5b1

						.peer
							margin-right: 8px
							color: #4dbd74

						.kind
							margin-right: 8px
							color: #f0b400

						.action
							margin-right: 8px
							font-weight: bold

						.details
							color: #9da5b1

				.empty
					display: flex
					justify-content: center
					padding: 2rem

					span
						color: #9da5b1

</style>
